module.exports = __webpack_public_path__ + "img/npc_logo.c9b2c1b1.png";